import type { ArrivalPlaceholderResponse, ArrivalStepKind } from '@/shared/api';
import { splitTokens, type InsertOption, type Segment } from '@/shared/components';

// Wie der Server: in einem Parkhinweis ist ein zeitgesperrtes Feld nicht erlaubt, weil der Gast den
// Hinweis sofort braucht und bis zwölf Stunden vor der Anreise nur „•••“ sähe.
const LOCKED_IN_PARKING = {
  short: 'nicht in Parkhinweisen',
  why: 'Erscheint erst 12 Stunden vor der Anreise – ein Parkhinweis muss sofort lesbar sein.',
};

const blockedHere = (placeholder: ArrivalPlaceholderResponse, guide: ArrivalStepKind) =>
  guide === 'ParkingAlternatives' && placeholder.isTimeLocked;

/** Was „Feld einfügen“ anbietet: jedes Feld mit Beschreibung, gesperrte mit Grund. */
export function arrivalInsertOptions(
  placeholders: ArrivalPlaceholderResponse[],
  guide: ArrivalStepKind,
): InsertOption[] {
  return placeholders.map((placeholder) => {
    const option = {
      token: `{{${placeholder.token}}}`,
      label: placeholder.token,
      example: placeholder.isTimeLocked ? 'ab 12 h vor Anreise' : '',
      detail: placeholder.description,
    };
    return blockedHere(placeholder, guide) ? { ...option, blocked: LOCKED_IN_PARKING } : option;
  });
}

/** Hervorhebung im Textfeld: bekannte Felder, unbekannte und hier gesperrte. */
export function arrivalSegments(
  value: string,
  placeholders: ArrivalPlaceholderResponse[],
  guide: ArrivalStepKind,
): Segment[] {
  return splitTokens(value, (token) => {
    const name = token.slice(2, -2).trim();
    const known = placeholders.find(
      (placeholder) => placeholder.token.toLowerCase() === name.toLowerCase(),
    );
    if (!known) return 'unknown';
    return blockedHere(known, guide) ? 'misplaced' : 'field';
  });
}
